<carm-load-spinner-wrapper>
  <div id="myGrid{{inId}}" class="table-content" [ngClass]="{'no-content-border': noContentBorder}"  style="width: 100%;">
      <div class="flex-full-width-row" *ngIf="!agGridConfig.hideQuickFilter">
          <div class="flex-input-left">
            <label class="table-advanced-label" id="label-filterItems{{inId}}">
              {{'ag_grid_component.filter_items' | translate}}
            </label>
            <input class="table-advanced-input form-control"
                  [attr.aria-labelledby]="'label-filterItems'+inId"
                  matInput (keyup)="applyFilter($event.target.value)"
                  id="filter-{{inId}}">
          </div>
      </div>
      <ng-content select="[externalFilters]"></ng-content>
      <ag-grid-angular
        style="width: 100%;" class="ag-theme-material"
        [class.fixed-height]="!autoHeight"
        [class.fixed-height-with-custom-paging]="!!customServerSidePaging"
        [gridOptions]="gridOptions"
        [localeText]="localeText"
        [rowSelection]="rowSelection"
        (paginationChanged)="onPaginationChanged($event)"
        (firstDataRendered)="onFirstDataRendered($event)"
        (sortChanged)="onClientSortChanged($event)"
      >
      </ag-grid-angular>
      <ng-template *ngIf="!!customServerSidePaging" [ngTemplateOutlet]="customPaging"></ng-template>
      <div class="pagesize-container" [class]="{'page-bottom': bottomPagePosition===true}" [class.infinite-paging]="gridOptions.rowModelType === 'infinite'" *ngIf="itemPageSize">
        <form [formGroup]="pageSizeGroup">
        <label class="items-per-page-label" id="label-items-per-page{{inId}}">{{'ag_grid_component.items_per_page_label' | translate}}</label>:
        <select (change)="onPageSizeChanged($event)" id="page-size{{inId}}" formControlName="sizeSelect"
        [attr.aria-labelledby]="'label-items-per-page'+inId">
          <option value="10" selected="">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100" *ngIf="minPageSize>=100">100</option>
          <option value="500" *ngIf="minPageSize>=500">500</option>
          <option value="1000" *ngIf="minPageSize>=1000">1000</option>
        </select>
      </form>
      </div>
  </div>
</carm-load-spinner-wrapper>

<ng-template #customPaging>
  <div class="ag-theme-material">
    <div class="ag-root-wrapper ag-layout-normal ag-ltr">
      <div class="ag-paging-panel ag-unselectable">
        <span ref="eSummaryPanel" class="ag-paging-row-summary-panel">
            <span ref="lbFirstRowOnPage" class="ag-paging-row-summary-panel-number">
              {{ customServerSidePaging.page === 0 ? (customServerSidePaging.recordCount === 0 ? 0 : 1) :
                customServerSidePaging.hasNext === true ?
                  (customServerSidePaging.recordCount * (customServerSidePaging.page )) :
                  (customServerSidePaging.page * customServerSidePaging.count)
              }}</span>
            {{ 'custom_paging.to' | translate}}
            <span ref="lbLastRowOnPage" class="ag-paging-row-summary-panel-number">
              {{ customServerSidePaging.hasNext === true ?
                  (customServerSidePaging.recordCount * (customServerSidePaging.page )) :
                  (customServerSidePaging.totalCount)
              }}</span>
            {{ 'custom_paging.of' | translate}}
            <span ref="lbRecordCount" class="ag-paging-row-summary-panel-number">{{customServerSidePaging.totalCount}}</span>
        </span>
        <span class="ag-paging-page-summary-panel">
            <div ref="btFirst" class="ag-paging-button-wrapper" (click)="onPreviousClicked($event, true)" [ngClass]="{'ag-disabled': !customServerSidePaging.hasPrevious}">
                <span class="ag-icon ag-icon-first" unselectable="on"></span>
            </div>
            <div ref="btPrevious" class="ag-paging-button-wrapper" (click)="onPreviousClicked($event)" [ngClass]="{'ag-disabled': !customServerSidePaging.hasPrevious}">
                <span class="ag-icon ag-icon-previous" unselectable="on"></span>
            </div>
            <span class="ag-paging-description">
                {{ 'custom_paging.page' | translate}}
                <span ref="lbCurrent" class="ag-paging-number">{{customServerSidePaging.page === 0 && customServerSidePaging.totalPages === 0 ? 0 : (customServerSidePaging.page)}}</span>
                {{ 'custom_paging.of' | translate}}
                <span ref="lbTotal" class="ag-paging-number">{{customServerSidePaging.totalPages}}</span>
            </span>
            <span ref="lbTotal" class="ag-paging-number"></span>
            <div ref="btNext" class="ag-paging-button-wrapper" (click)="onNextClicked($event)" [ngClass]="{'ag-disabled': !customServerSidePaging.hasNext}">
              <span class="ag-icon ag-icon-next" unselectable="on"></span>
            </div>
            <div ref="btLast" class="ag-paging-button-wrapper" (click)="onNextClicked($event, true)" [ngClass]="{'ag-disabled': !customServerSidePaging.hasNext}">
              <span class="ag-icon ag-icon-last" unselectable="on"></span>
            </div>
          </span>
      </div>
    </div>
  </div>
</ng-template>
